export const saleTypeFeatureTranslationEN = {
  SaleTypeListPage: {
    head_title: '販売タイプ一覧',
    add_new: '追加',
    detailed: '詳細',
    copy: '複製',
    delete: '削除',
    selection: '選択',
    sale_type_name: '販売タイプ名',
    timeframe: '時間帯',
    timeframe_name: '名称',
    timeframe_time: '時間',
    menu_book_selection: 'メニューブック選択',
    menu_book_edit: 'メニューブック編集',
  },
  SaleTypeDetail: {
    head_title: '販売タイプ詳細',
    close: '閉じる',
    save: '保存',
    register_timeframe: '時間帯登録',
    timeframe_name: '時間帯名',
    apply_time: '適用時間',
    begin: '開始',
    end: '終了',
    add_row: '行追加',
    warn_field_required: 'この項目は必須です',
  },
  TimeFrameMenuBook: {
    head_title: '時間帯別メニューブック編集',
    add_menu_book: 'メニューブック追加',
    sale_type: '販売タイプ',
    timeframe: '時間帯',
    guide_title: '※並び順の変更について',
    guide_description:
      'メニューブック／コースは選択して、キーボード操作で並び順を変更することができます。<br />変更すると、モバイルオーダーのメニューブックボタンの並び順が変更になります。',
    selected_menu_book: '選択済メニューブック',
    course: 'コース',
  },
};
